/** Pulsująca kropka „na żywo” (ktoś jest teraz w sklepie). */
export function LiveDot() {
  return (
    <span aria-hidden className="relative flex size-2.5 shrink-0">
      <span className="absolute inline-flex size-full animate-ping rounded-full bg-brand-500 opacity-60 motion-reduce:hidden" />
      <span className="relative inline-flex size-2.5 rounded-full bg-brand-600" />
    </span>
  );
}
